// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"5b05adfb","29":"2d814367","70":"03eb15e6","82":"48f4beb0","116":"d3fda0f7","228":"025f45bb","326":"25771178","437":"aa1c9913","448":"d0148352","471":"14794509","749":"bb3d30bf","825":"b699b480","865":"2b5305a2","980":"5f5d797d"}[chunkId] + ".chunk.js";
};